import React, {ComponentProps} from 'react';

import {pluralise} from '@optimaxdev/utils';
import classNames from 'classnames';

import {useFeature} from 'components/feature/feature';

import {Price} from 'components/price/price';
import {RebateOffer} from 'desktop/pages/checkout/components/rebateOffer/rebateOffer';

import s from './rebateWidget.scss';

export type PropsType = {
    currentDiscount?: number | null;
    qtyToDiscount?: number;
    nextDiscount?: number;
    className?: string;
    containerClassName?: string;
    isContactLensesPla?: boolean;
    eventName: ComponentProps<typeof RebateOffer>['eventName'];
};

/**
 * renders rebate offer
 *  @returns {React.ReactElement} - Rebate offer
 */
export const RebateWidget: React.FC<PropsType> = ({
    className = '',
    containerClassName = '',
    currentDiscount,
    eventName,
    isContactLensesPla = false,
    nextDiscount,
    qtyToDiscount,
}) => {
    const isCLRebate = useFeature('clRebate');

    const isDisplayWidget = qtyToDiscount && nextDiscount;

    if (!isCLRebate || isContactLensesPla || (!currentDiscount && !isDisplayWidget)) return null;

    return (
        <div className={classNames(s.container, containerClassName)}>
            <div className={className}>
                {currentDiscount && (
                    <RebateOffer eventName={eventName}>
                        You qualify for a <Price>{currentDiscount}</Price> rebate
                    </RebateOffer>
                )}
                {isDisplayWidget && (
                    <div
                        className={classNames(s.rebateWidget, {
                            [s.rebateWidgetWithoutMargin]: !currentDiscount,
                        })}
                    >
                        Add {qtyToDiscount} more {pluralise('box', qtyToDiscount)} & get a{' '}
                        <Price>{nextDiscount}</Price> rebate.
                    </div>
                )}
            </div>
        </div>
    );
};
